import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import CountUp from 'react-countup';
import UserSvg from '@src/svgs/fr-custom-users.svg';
import './styles.scss';

export default class Reach extends PureComponent {
  static propTypes = {
    count: PropTypes.number.isRequired,
    loadingReach: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
  };

  state = {
    oldCount: 0,
  };

  componentWillReceiveProps() {
    this.setState({ oldCount: this.props.count });
  }

  formatCount(value) {
    if (value < 100) {
      return '< 100';
    }
    return value;
  }

  render() {
    const { title, count, loadingReach } = this.props;
    const { oldCount } = this.state;

    return (
      <div className="reach">
        <span className="reach__title">{title}</span>
        <div className="reach-count">
          <Svg src={UserSvg} />
          {loadingReach ? (
            <span className="reach-count-calculating">calculating...</span>
          ) : (
            <CountUp end={count} formattingFn={this.formatCount} start={oldCount} />
          )}
        </div>
      </div>
    );
  }
}
